import React from 'react';
import './Header.css';

function Header() {
  return (
    <header className="app-header">
      <div className="header-content">
        <img src="/hungry_fonz_header_logo.png" alt="The Hungry Fonz Logo" className="logo" />
        <h1 className="website-name">The Hungry Fonz</h1>
        <button className="sign-in-button">Sign In</button>
      </div>
      <nav className="navigation">
        <a href="#home">Home</a>
        <a href="#meals">Meals</a>
        <a href="#cuisines">Cuisines</a>
        <a href="#dishes">Dishes</a>
        <a href="#diets">Diets</a>
        <a href="#aboutus">About Us</a>
      </nav>
    </header>
  );
}

export default Header;